import React from 'react'
import {Link} from 'react-router-dom'

import image from '../assets/images/hiring.jpg'
import {ContactInfo} from '../components/'

const HiringData = () => (
    <div className="container contact-page">
        <div className="row contact">
            <div className="col-sm-12 col-md-6 contact-title">Kariera</div>
            <div className="col-sm-12 col-md-6 contact-text">
                Trenutno ste tukaj:{' '}
                <Link className="breadcrumbs-link" to="/">
                    Domov
                </Link>{' '}
                <i className="fas fa-angle-right breadcrumbs-icon" /> Kariera
            </div>
        </div>
        <div className="row clearfix">
            <div className="col-sm-12 col-md-4 contact-details">
                <ContactInfo />
            </div>
            <div className="col-sm-12 col-md-8 contact-map clearfix">
                <h4>Išče se Python, PHP programer (m/ž)</h4>
                <img className="hiring-img" src={image} alt="Išče se Python, PHP programer" />
                <div className="hiring-text">
                    <p>
                        Zaradi načrtovanja povečanja obsega del želimo našo razvijalsko ekipo
                        okrepiti. Ponujamo možnost dolgoročnega sodelovanja, prijetno in dinamično
                        okolje, možnost strokovnega in osebnega razvoja, ter pridobivanja
                        mednarodnih izkušenj.
                    </p>

                    <h4>Opis delovnega mesta</h4>

                    <p>
                        - Sodelovanje pri definiranju tehničnih zahtev za programsko opremo<br />
                        - Razvoj programske opreme z uporabo dogovorjenih metod oz. tehnik ter
                        izbranih programerskih orodij<br />
                        - Izvajanje aktivnosti za zagotavljanje in nadzor kakovosti in preizkušanja
                        programske opreme<br />
                        - Vzdrževanje in izpopolnjevanje programske opreme
                    </p>

                    <h4>Zahtevana znanja</h4>

                    <p>
                        Python (Django), Objektni PHP, JavaScript, jQuery, CSS, HTML, WordPress,
                        Laravel, Git, Android. Vsaj nekaj izkušenj z delom na projektih.
                        Samoiniciativnost, komunikativnost, znanje angleščine, spremljanje novih
                        tehnologij. Dvodnevni preizkus. Projektno delo, možnost dolgoročnega
                        sodelovanja.
                    </p>

                    <h4>Delovni čas</h4>

                    <p>Polni delovni čas</p>

                    <h4>Trajanje dela</h4>

                    <p>Po dogovoru z naročnikom, možnost dolgoročnega sodelovanja</p>

                    <h4>Izobrazba</h4>

                    <p>
                        Višji letnik računalništva oz. kuhar z odličnim znanjem programiranja (to
                        zadnje je fora)
                    </p>

                    <h4>Info in prijava</h4>

                    <p>Kandidati pošljejo CV in reference na info@graficnistudio.net</p>
                </div>
            </div>
        </div>
    </div>
)

export default HiringData



// WEBPACK FOOTER //
// ./src/components/HiringData.js